import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';

const uploadToken = () => {
  return axios.post('/getUrl');
};

export const useUploadUrl = uploadKey => {
  return useQuery({
    queryKey: ['uploadUrl', uploadKey],
    queryFn: uploadToken,
    select: data => {
      return data.data;
    }
  });
};